import React from 'react';
import { Rocket, Sparkles, Heart } from 'lucide-react';

export default function Mission({ onNavigate }) {

    return (
        <div className="animate-fade-in" style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '40px 20px',
            paddingBottom: '100px',
            color: 'var(--text-main)'
        }}>
            {/* Header */}
            <div className="glass-panel" style={{ padding: '40px', textAlign: 'center', marginBottom: '30px' }}>
                <div style={{
                    background: 'linear-gradient(135deg, #ec4899 0%, #8b5cf6 100%)',
                    width: '80px',
                    height: '80px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 20px',
                    boxShadow: '0 10px 30px rgba(236, 72, 153, 0.5)'
                }}>
                    {/* Mascot */}
                    <img
                        src="/images/mascots/SparkGG.png"
                        alt="SparkGG Mascot"
                        style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '50%' }}
                        onError={(e) => {
                            e.target.style.display = 'none';
                            e.target.nextSibling.style.display = 'block';
                        }}
                    />
                    {/* Fallback Icon */}
                    <div style={{ display: 'none' }}>
                        <Rocket size={40} color="white" />
                    </div>
                </div>
                <h1 style={{ fontSize: '3rem', fontWeight: '800', marginBottom: '10px', color: 'var(--text-main)' }}>
                    Our Mission
                </h1>
                <p style={{ fontSize: '1.2rem', opacity: 0.8, maxWidth: '600px', margin: '0 auto' }}>
                    Transforming moments of boredom into sparks of creative inspiration.
                </p>
            </div>

            {/* Content */}
            <div className="glass-panel" style={{ padding: '40px', marginBottom: '30px' }}>
                <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--secondary)' }}>
                    <Sparkles size={24} />
                    From Boredom to Brilliance
                </h2>
                <p style={{ lineHeight: '1.8', opacity: 0.9, marginBottom: '20px' }}>
                    We believe that boredom isn't just a lack of activity—it's a blank canvas waiting for a masterpiece. In a world full of passive consumption, we're building a space for <strong>active creation</strong>.
                </p>
                <p style={{ lineHeight: '1.8', opacity: 0.9, marginBottom: '20px' }}>
                    Our platform connects users with "Sparks"—unique, bite-sized creative prompts designed to ignite your imagination. Whether you have 5 minutes or 5 hours, we help you find that initial push to make something amazing.
                </p>
                <p style={{ lineHeight: '1.8', opacity: 0.9, marginBottom: '20px' }}>
                    <strong>Here's the twist:</strong> Our AI-powered inspiration engine (powered by Google Gemini) flips the script on traditional AI. Instead of <em>you</em> asking AI to be creative, <strong>the AI challenges YOU</strong> to create. It's reverse AI—a fun experiment where artificial intelligence becomes your creative coach, not your replacement.
                </p>

                <h2 style={{ display: 'flex', alignItems: 'center', gap: '10px', color: '#fda4af', marginTop: '40px' }}>
                    <Heart size={24} />
                    Community First
                </h2>
                <p style={{ lineHeight: '1.8', opacity: 0.9 }}>
                    We are more than just a tool; we are a community of dreamers, makers, and doers. We check our egos at the door and support each other's creative journeys. Respect, safety, and encouragement are the pillars of our interactions.
                </p>
            </div>

            <div style={{ textAlign: 'center' }}>
                <button onClick={() => onNavigate && onNavigate('feed')} className="btn-primary" style={{ padding: '15px 40px', fontSize: '1.1rem' }}>
                    Join the Movement
                </button>
            </div>
        </div>
    );
}
